// フッター「ページトップへ」— scrollY が閾値を超えたら表示

class CmBackToTop extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const link = this.querySelector('[data-back-to-top-link]');
    if (!link) return;

    const threshold = Number(this.dataset.scrollThreshold) || 200;

    const update = () => {
      const isVisible = window.scrollY > threshold;
      link.classList.toggle('is-visible', isVisible);
      link.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      link.tabIndex = isVisible ? 0 : -1;
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }
}

if (!customElements.get('cm-back-to-top')) {
  customElements.define('cm-back-to-top', CmBackToTop);
}
